// extracted by mini-css-extract-plugin
export default {"deleteAttire--content":"deleteAttire_deleteAttire--content__BQ20-","deleteAttire--content-btnContainer":"deleteAttire_deleteAttire--content-btnContainer__RA-c2"};